import GeneralTracker from '../GeneralTracker';


export default class BroadcasterPageNavigationTracker extends GeneralTracker {
  CAPTURE_NAME = 'session:user:profile:navigation';
  VERSION = '1';

  setHandlers() {
    const service = this.getService();
    service.on('broadcasterPageTabClick', this.onBroadcasterPageTabClick);
    service.on('profileGalleryInteraction', this.onGalleryInteraction);
  }

  onBroadcasterPageTabClick = (payload) => {
    const trackPayload = {
      action: 'click',
      tag: payload,
    };

    this.track(trackPayload);
  };

  onGalleryInteraction = (payload) => {
    this.track(payload);
  };
}
